import {ImageBackground, Pressable, ScrollView, Text, View} from "react-native";
import React, {useEffect} from "react";
import {createNativeStackNavigator} from "@react-navigation/native-stack";

import {styles, TAB_BAR_HEIGHT} from "../common/styles";
import {WhiteViewHeader} from "../common/WhiteViewHeader";
import {i18n} from "../common/localization";
import {API_URL} from "../common/constants";
import {authenticatedFetch} from "../common/auth";
import {SocialMenu} from "./SocialMenu";
import TriangleIcon from "../icons/TriangeIcon";
import {ActivityIndicatorView} from "../common/ActivityIndicatorView";
import {normalizeMenuSections} from "./menuData";

import socialMenuButton from "../assets/menu-social-menu-button.jpg";
import menuButton from "../assets/menu-menu-button.jpg";
import wineCardButton from "../assets/menu-wine-button.jpg"
import bg from "../assets/restaurant-bg.png";

const Stack = createNativeStackNavigator();

export const MenuNavigator = () => {
    const [isLoading, setIsLoading] = React.useState(false);
    const [menuData, setMenuData] = React.useState([]);
    const [socialMenuData, setSocialMenuData] = React.useState([]);
    const [wineCardData, setWineCardData] = React.useState([]);

    useEffect(() => {
        getData();
    }, []);

    function getData() {
        setIsLoading(true);

        authenticatedFetch(API_URL + "/menu-sections", {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
                    .then((response) => {
                        if (!response.ok) {
                            throw new Error(`Unable to load menu sections (${response.status})`);
                        }
                        return response.json();
                    })
                    .then((result) => {
                        const data = normalizeMenuSections(result);
                        setMenuData(data.filter((section) => section.type === "food"));
                        setWineCardData(data.filter((section) => section.type === "vine"));
                        setSocialMenuData(data.filter((section) => section.type === "social"))
                    })
                    .catch((error) => {
                        // TODO: Show error
                        console.log(error);
                    })
                    .finally(() => {
                        setIsLoading(false);
                    });
    }

    return (
        <>
            <Stack.Navigator>
                <Stack.Screen
                    name="Home"
                    component={MenuHome}
                    options={{ headerShown: false }}
                />
                <Stack.Screen
                    name="SocialMenu"
                    options={{ headerShown: false }}
                >
                    {(props) => <SocialMenu {...props}
                                            title={i18n.t("socialMenu")}
                                            data={socialMenuData} />}
                </Stack.Screen>
                <Stack.Screen
                    name="Menu"
                    options={{ headerShown: false }}
                >
                    {(props) => <SocialMenu {...props}
                                            title={i18n.t("menu")}
                                            data={menuData} />}
                </Stack.Screen>
                <Stack.Screen
                    name="WineCard"
                    options={{ headerShown: false }}
                >
                    {(props) => <SocialMenu {...props}
                                            title={i18n.t("wineCard")}
                                            data={wineCardData} />}
                </Stack.Screen>
            </Stack.Navigator>
            <ActivityIndicatorView isVisible={isLoading} color={"grey"} />
        </>

    )
}

export const MenuHome = ({ navigation }) => {
    function onPressSocialMenu() {
        navigation.navigate('SocialMenu');
    }

    function onPressMenu() {
        navigation.navigate('Menu');
    }

    function onPressWineCard() {
        navigation.navigate('WineCard');
    }

    return (
        <View style={styles.container}>
            <ImageBackground source={bg} resizeMode="contain" style={{...styles.whiteViewBgImageContainer, width: 271, height: 118}} />
            <View style={{...styles.whiteViewContainer, paddingBottom: TAB_BAR_HEIGHT}}>
                <WhiteViewHeader/>
                <ScrollView style={styles.whiteViewScrollView}>
                    <Text style={styles.whiteViewTitleText}>{i18n.t("menu")}</Text>
                    <View style={styles.whiteViewScrollViewInnerContainer}>
                        <ImageBackground source={socialMenuButton} resizeMode="cover" style={styles.menu.tileButton} >
                            <Pressable onPress={onPressSocialMenu} style={styles.menu.tileButtonContainer}>
                                <Text style={styles.menu.tileButtonTitle}>{i18n.t("socialMenu")}</Text>
                            </Pressable>
                        </ImageBackground>
                        <TriangleIcon color="#FFC700" style={styles.colorTriangle} />
                    </View>
                    <View style={styles.whiteViewScrollViewInnerContainer}>
                        <ImageBackground source={menuButton} resizeMode="cover" style={styles.menu.tileButton} >
                            <Pressable onPress={onPressMenu} style={styles.menu.tileButtonContainer}>
                                <Text style={styles.menu.tileButtonTitle}>{i18n.t("menu")}</Text>
                            </Pressable>
                        </ImageBackground>
                        <TriangleIcon color="#FF7A00" style={styles.colorTriangle} />
                    </View>
                    <View style={styles.whiteViewScrollViewInnerContainer}>
                        <ImageBackground source={wineCardButton} resizeMode="cover" style={styles.menu.tileButton} >
                            <Pressable onPress={onPressWineCard} style={styles.menu.tileButtonContainer}>
                                <Text style={styles.menu.tileButtonTitle}>{i18n.t("wineCard")}</Text>
                            </Pressable>
                        </ImageBackground>
                        <TriangleIcon color="#DA3C53" style={styles.colorTriangle} />
                    </View>
                </ScrollView>
            </View>
        </View>
    )
}
